/*
  Lunveil — fiche produit et cartes.
  - Lecteur « Écouter » : un seul son à la fois sur la page (fiche [data-lx-son], cartes [data-lx-son-btn]).
  - Choix « notes / accordage » : coche la variante correspondante dans le sélecteur du thème (masqué),
    qui se charge du prix, du bouton, de l'URL et de la disposition des notes.
  - Ligne PayPal 4× : montant recalculé au changement de variante.
  Inclus par plusieurs blocs : ne s'initialise qu'une fois.
*/
(function () {
  'use strict';
  if (window.lxFiche) return;
  window.lxFiche = true;

  /* ---------- son ---------- */
  var audio = null;
  var courant = null; // élément qui joue : .lx-son ou bouton de carte

  function barres(el) {
    return el ? el.querySelectorAll('.lx-son__wave i') : [];
  }

  function etat(el, joue) {
    if (!el) return;
    el.classList.toggle('is-playing', joue);
    var bouton = el.matches('button') ? el : el.querySelector('.lx-son__play');
    if (bouton) bouton.setAttribute('aria-pressed', String(joue));
    if (!joue) barres(el).forEach(function (b) { b.classList.remove('on'); });
  }

  function arreter() {
    if (audio) audio.pause();
    etat(courant, false);
    courant = null;
  }

  function jouer(el, src) {
    if (courant === el) return arreter();
    arreter();
    if (!audio) {
      audio = new Audio();
      audio.preload = 'none';
      audio.addEventListener('timeupdate', function () {
        if (!courant || !audio.duration) return;
        var fr = audio.currentTime / audio.duration;
        var bs = barres(courant);
        bs.forEach(function (b, i) { b.classList.toggle('on', i / bs.length < fr); });
      });
      audio.addEventListener('ended', arreter);
      audio.addEventListener('error', arreter);
    }
    if (audio.getAttribute('src') !== src) audio.src = src;
    audio.currentTime = 0;
    courant = el;
    etat(el, true);
    var p = audio.play();
    if (p && p.catch) p.catch(arreter);
  }

  document.addEventListener('click', function (e) {
    var carte = e.target.closest('[data-lx-son-btn]');
    if (carte) {
      e.preventDefault();
      jouer(carte, carte.getAttribute('data-lx-son-btn'));
      return;
    }
    var bouton = e.target.closest('.lx-son__play');
    if (bouton) {
      var bloc = bouton.closest('[data-lx-son]');
      if (bloc) jouer(bloc, bloc.getAttribute('data-lx-son'));
    }
  });

  /* ---------- choix notes / accordage ---------- */
  document.addEventListener('change', function (e) {
    var choix = e.target.closest('[data-lx-choix]');
    if (!choix || e.target.type !== 'radio') return;
    var sep = choix.getAttribute('data-sep') || ' – ';
    var groupes = choix.querySelectorAll('.lx-fchoix__grp');
    var valeurs = [];
    groupes.forEach(function (g, i) {
      var c = g.querySelector('input:checked');
      valeurs.push(c ? c.value : '');
      var aff = choix.querySelector('[data-lx-choix-val="' + i + '"]');
      if (aff && c) aff.textContent = c.value;
    });
    var cible = valeurs.join(sep);
    var form = choix.closest('form') || document;
    var radios = form.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === cible) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
      }
    }
  });

  /* ---------- carte des notes ---------- */
  function carteNotes(section, n) {
    n = String(n);
    section.querySelectorAll('[data-n]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-n') === n)); });
    section.querySelectorAll('[data-ligne]').forEach(function (l) { l.hidden = l.getAttribute('data-ligne') !== n; });
    section.querySelectorAll('.lx-notes__x').forEach(function (x) { x.classList.toggle('is-off', parseInt(x.getAttribute('data-des'), 10) > parseInt(n, 10)); });
  }
  document.querySelectorAll('[data-lx-notes]').forEach(function (s) {
    var actif = s.querySelector('.lx-notes__seg [aria-pressed="true"]') || s.querySelector('.lx-notes__seg [data-n]');
    if (actif) carteNotes(s, actif.getAttribute('data-n'));
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-notes] [data-n]');
    if (b) carteNotes(b.closest('[data-lx-notes]'), b.getAttribute('data-n'));
  });
  document.addEventListener('variant:updated', function (e) {
    var v = e.detail && e.detail.resource;
    var m = v && v.title && String(v.title).match(/^(\d+)\s+notes/);
    if (m) document.querySelectorAll('[data-lx-notes]').forEach(function (s) { carteNotes(s, m[1]); });
  });

  /* ---------- PayPal 4× ---------- */
  var nombre = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  document.addEventListener('variant:updated', function (e) {
    var v = e.detail && e.detail.resource;
    if (!v || typeof v.price !== 'number') return;
    document.querySelectorAll('[data-lx-4x]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || Infinity;
      el.hidden = v.price < min || v.price > max;
      var m = el.querySelector('[data-lx-4x-montant]');
      if (m) m.textContent = m.textContent.replace(/\d[\d\s\u202f.,]*\d/, nombre.format(Math.floor(v.price / 4) / 100));
    });
  });
})();
